<template>
  <div>
    <div class="bg" style="background-color:#E8E8E8"></div>
    <div class="u-hd">
        <div class="hd-bk" @click="closeModle">
            <i class="icon iconback"></i>&nbsp;返回
        </div>
        <div class="hd-tl">结算单详情</div>
        <div class="hd-mu">
            <div style="padding-left:48px"><i class="icon icongengduo2" @click="showShare=true"></i></div>
        </div>
    </div>
    <van-share-sheet
        v-model="showShare"
        title="立即分享给好友"
        :options="options"
        @select="onSelect"
    />
    <div style="height:44px"></div>
    <div style="display:flex;align-items: center;">
        <div style="padding:5px 10px;" :style="{color:form.state=='NOAUDIT'?'#FF8518':'#4935ae'}">
            <i class="icon icondanju" style="font-size:50px;"></i>
        </div>
        <div style="width:calc(100% - 90px);">
            <div class="add-ord-title">结算单详情&nbsp;<span style="font-size:12px">({{form.no?form.no:'00000000000'}})</span></div> 
           <div class="add-ord-desc" style="display:flex">
                <div style="flex:1">{{form.merchantName}}</div>
                <div style="width:100px;text-align:right;color:#4c37b6">{{moment(form.operatorTime).format("YYYY-MM-DD")}}</div>
            </div>
        </div>
    </div>
    <div style="background:#fff;margin:0 13px;width:calc(100vw - 25px;);border-top-left-radius:5px;border-top-right-radius:5px;overflow:hidden">
        <div class="sum" style="display:flex;align-items: center;background-color:#4C37B6;padding:10px 0px">
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.unpaidAmountYuan | money}}</div>
                <div class="sum-txt">应付金额</div>
            </div>
            <div style="width:1px;height:20px;background:#8470e6"></div>
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.paidAmountYuan | money}}</div>
                <div class="sum-txt">实付金额</div>
            </div>
            <div style="width:1px;height:20px;background:#8470e6"></div>
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.giftAmountYuan | money}}</div>
                <div class="sum-txt">优惠金额</div>
            </div>
            <div style="width:1px;height:20px;background:#8470e6"></div>
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.noPaidAmount | money}}</div>
                <div class="sum-txt">未付金额</div>
            </div>
        </div>
        <detali-table :isShow="isShow" :order="form" :details="details" bindchangeTable="changeState"></detali-table>
    </div>
    <!-- <div class="fixed-submit" style="width:calc(100vw - 25px);left:13px">
        <div style="background-color:#FFF;width:calc(100% - 100px);display: flex;">
            <div class="btn" style="justify-content: flex-start;padding-left:10px">
                <div class="btn-text" style="font-size:13px;color:#4c37b6">待付合计：<span style="font-weight:600;font-size:16px">{{form.noPaidAmount | money}}</span></div>
            </div>
        </div>
        <div style="width:100px;background-color:#ff8518;display:flex" @click="goBack">
            <div class="btn" >
                <i class="icon iconfanhui1"></i>
                <div class="btn-text">返回</div>
            </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import detailsTable from './detailsTable';
export default {
    components:{
        'detali-table':detailsTable
    },
    data() {
        return {
            form: {},
            details: [{}],
            active: 0,
            showBatchNoModel: false,
            state: 1,
            showShare:false,
            isShow: false,
            showPreOrderModel: false,
            moreKey: {},
            typeList: [],
            priceSetting: '',
            planappoint: '',
            plantype: '',
            planladder: '',
            plandiscount: ''
        }
    },
    created(){
        console.log(this.$route.query.id)
        this.$request.get("statementOrders/settleBillOrderDetail?id="+this.$route.query.orderId).then(data=>{
            this.form=data.content.settleBill
            this.details=data.content.detailList
        })
    },
    methods:{
        changeTab(name, title) {
            this.active=name
        },
        goBack(){
            this.router.go(-1)
        },
        save() {
            this.$request.post("purchaseOrder/handleOrder", {orderId:this.$route.query.id}).then(data => {
                if (data.status == 200) {
                    this.$request.get("purchaseOrder/orderDetail?orderId="+this.$route.query.id).then(data=>{
                        this.form=data.content.settleBill
                        this.details=data.content.detailList
                    })
                } else {
                    wx.showToast({
                        icon: 'none',
                        title: data.message
                    })
                }
            })
        },
        closeModle(){
            this.router.go(-1)
        }
    }
}
</script>

<style scoped>

.add-ord-title{
    font-size: 16px;
    padding-bottom:5px;
    border-bottom:1px solid #aaa
}

.add-ord-desc{
    font-size:13px;
}
.order-price{
    color:#F56C6C;
    font-weight: 600
}


.add-tabs{
    font-size:15px !important;
    font-weight:700
}



.model-bg {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1;
    height: calc(100vh - 65px);
    width: 50vw;
    background-color: rgba(0, 0, 0, 0.78);
  }
  .sum-val{
    font-weight: 600;
    margin-bottom:3px;
  }
  .sum-txt{
    font-size:12px;
    color:#cabfff
  }
</style>


// WEBPACK FOOTER //
// src/views/settleBill/detail.vue